import { Model } from '../../api/model';

export class CurrencyModel extends Model {

    public status: string;
    public delimiter: string;
    public format: string;
    public code: string;
    public iso: string;
    public name: string;
    public precision: number;
    public exchange_rate: number;
    public separator: string;
    public symbol: string;

    public boot(data: Object = {}) {
        super.boot(data);

        // this.exchange_rate =
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/currency/models/currency.model.ts